import {
  DeleteConfirmationDialog,
  IntroDialog,
  PasswordChangeDialog,
  RefreshAccountConfirmationDialog,
  SettingsButton,
} from '@abdoo/common';
import DeleteIcon from '@mui/icons-material/Delete';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, Grid } from '@mui/material';
import { useCallback, useState } from 'react';

const HolidayYearSettingsModal = (props: { open: boolean; finish: () => void }) => (
  <IntroDialog open={props.open} type="manageHolidayYear" finish={props.finish} />
);

const ManagerSettingsModal = (props: { open: boolean; finish: () => void }) => (
  <IntroDialog open={props.open} type="manager" finish={props.finish} />
);

export const SettingsPage = () => {
  const [showHolidayYearSettingsModal, setShowHolidayYearSettingsModal] = useState(false);
  const [showManagerSettingsModal, setShowManagerSettingsModal] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showPasswordDialog, setShowPasswordDialog] = useState(false);
  const [showRefreshDialog, setShowRefreshDialog] = useState(false);

  const manageHolidayYearClicked = useCallback(() => {
    setShowHolidayYearSettingsModal(true);
  }, []);

  const manageHolidayYearModalClosed = useCallback(() => {
    setShowHolidayYearSettingsModal(false);
  }, []);

  const managerSettingsClicked = useCallback(() => {
    setShowManagerSettingsModal(true);
  }, []);

  const managerSettingsModalClosed = useCallback(() => {
    setShowManagerSettingsModal(false);
  }, []);

  const handleDelete = useCallback(() => {
    setShowDeleteDialog(true);
  }, []);

  const handlePasswordChange = useCallback(() => {
    setShowPasswordDialog(true);
  }, []);

  const handleRefreshAccount = useCallback(() => {
    setShowRefreshDialog(true);
  }, []);

  return (
    <Grid
      container
      item
      justifyContent="center"
      marginTop={'50px'}
      paddingLeft={'0.8rem'}
      paddingRight={'0.8rem'}
      paddingBottom={'30px'}
    >
      <Box display="flex" justifyContent="center" flexDirection="column" gap={3}>
        <SettingsButton
          icon={<EditCalendarIcon />}
          text="Manage your entitlement year settings"
          onClick={manageHolidayYearClicked}
        />
        <SettingsButton
          icon={<ManageAccountsIcon />}
          text="Manage your approval request details"
          onClick={managerSettingsClicked}
        />
        <SettingsButton
          icon={<SettingsIcon />}
          text="Change your password"
          onClick={handlePasswordChange}
        />
        <SettingsButton
          icon={<RefreshIcon />}
          text="Reset your account"
          onClick={handleRefreshAccount}
        />
        <SettingsButton
          icon={<DeleteIcon />}
          text="Delete your account"
          color="error"
          onClick={handleDelete}
        />
      </Box>
      {showHolidayYearSettingsModal && (
        <HolidayYearSettingsModal
          open={showHolidayYearSettingsModal}
          finish={manageHolidayYearModalClosed}
        />
      )}
      {showManagerSettingsModal && (
        <ManagerSettingsModal
          open={showManagerSettingsModal}
          finish={managerSettingsModalClosed}
        />
      )}
      <DeleteConfirmationDialog
        showDialog={showDeleteDialog}
        setShowDialog={setShowDeleteDialog}
      />
      <PasswordChangeDialog
        showDialog={showPasswordDialog}
        setShowDialog={setShowPasswordDialog}
      />
      <RefreshAccountConfirmationDialog
        showDialog={showRefreshDialog}
        setShowDialog={setShowRefreshDialog}
      />
    </Grid>
  );
};
